import React from "react";
import Container from "react-bootstrap/Container";
import ReactPaginate from "react-paginate"; 
import styled from "styled-components";
import { labelText } from "../../lib/constants";

const StyledContainer = styled(Container)`
  .pagination .page-link {
    color: #04547d;
  }

  .pagination .page-link:hover {
    color: #033a57;
  }
  .pagination .page-link:focus {
    box-shadow: none;
  }

  .pagination .active .page-link {
    background-color: #04547d;
    border-color: #04547d;
    color: #ffffff;
  }

  .pagination .page-item.disabled .page-link {
    color: #6c757d;
  }
`;

export const PaginationComponent = ({ page, pageCount, handler }) => (
    <StyledContainer className="p-2 d-flex flex-column justify-content-center">
      <ReactPaginate
        forcePage={page}
        nextLabel={labelText.next_page}
        previousLabel={labelText.previous_page}
        onPageChange={handler}
        pageRangeDisplayed={10}
        pageCount={pageCount}
        renderOnZeroPageCount={null}
        containerClassName="pagination align-self-center"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        activeClassName="active"
        previousClassName="page-item"
        nextClassName="page-item"
        previousLinkClassName="page-link"
        nextLinkClassName="page-link"
        breakLinkClassName="page-link"
      />
    </StyledContainer>
);